module.exports = __webpack_public_path__ + "img/perfil_normal.bfda86c1.jpg";